import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { HistorialPagosDetalladosComponent } from './components/historial-pagos-detallados/historial-pagos-detallados.component';
import { ReportesRoutingModule } from './reportes-routing.module';
import { EpaycoCredijamarComponent } from './components/epayco-credijamar/epayco-credijamar.component';
import { GenerarPdfHistorialPagosService } from './components/services/generar-pdf-historial-pagos.service';
import { UtilsService } from './components/services/utils.service';
import { GenerarPdfDetalleCuotasService } from './components/services/generar-pdf-detalle-cuotas.service';
import { GenerarPdfEstadoCuentaService } from './components/services/generar-pdf-estado-cuenta.service';

@NgModule({
  declarations: [HistorialPagosDetalladosComponent, EpaycoCredijamarComponent],
  imports: [
    CommonModule,
    ImportsModule,
    ReportesRoutingModule,
  ],
  providers: [DatePipe, UtilsService, GenerarPdfDetalleCuotasService, GenerarPdfHistorialPagosService, GenerarPdfEstadoCuentaService]
})
export class ReportesModule { }
